/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_Chat_Chat_NameInputs */



/**
* | output |
* | --- |
* | "Chat Name" |
*
* @param {Form_Start_Chat_Chat_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_start_chat_chat_name = /** @type {((inputs?: Form_Start_Chat_Chat_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_Chat_Chat_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Chat-Name")
	return /** @type {LocalizedString} */ ("Chat Name")
});